<template>
  <v-img src="@/assets/login.jpg" style="height: 100%">
    <v-row justify="center">
      <v-col class="text-center" cols="12" md="5" lg="4" sm="12">
        <base-material-card icon="mdi-account" title="Login" class="px-5 py-1 ml-2 mr-2">
          <v-text-field
            v-model="payload.username"
            label="Username"
            append-icon="mdi-account-circle"
            outlined
          />
          <v-text-field
            v-model="payload.password"
            label="Password"
            :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
            :type="value ? 'password' : 'text'"
            outlined
            @click:append="() => (value = !value)"
          />
          <v-btn color="primary" block class="mb-5" @click="login()">Login</v-btn>
        </base-material-card>
      </v-col>
    </v-row>
  </v-img>
</template>

<script>
import authService from "../../service/Auth.service";
import userService from "../../service/User.service";

export default {
  name: "Login",
  data() {
    return {
      value: true,
      payload: {
        username: "",
        password: "",
      },
    };
  },
  created() {
    this.$store.commit("SET_DRAWER", false);
  },
  destroyed() {
    this.$store.commit("SET_DRAWER", false);
  },
  methods: {
    login() {
      authService
        .signIn(this.payload)
        .then(res => {
          this.$store.dispatch("setJwt", res.data.accessToken);
          localStorage.setItem("jwt", res.data.accessToken);
          userService
            .getCurrentUser(res.data.accessToken)
            .then(res => {
              this.$store.dispatch("setUser", res.data);
              localStorage.setItem("user", JSON.stringify(res.data));
              this.$router.push("/pages/user");
            });
        })
        .catch(err => {
          let n = err.toString().search("401");
          if (n) alert("Login yoki parolda xatolik bor");
        });
    },
  },
};
</script>

<style scoped>
</style>
